import { Component, inject, computed } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs/operators';
import { TopbarComponent } from './layout/topbar/topbar.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TopbarComponent, SidebarComponent],
  template: `
    @if (showLayout()) {
      <sw-topbar />
      <sw-sidebar />
      <main class="main-content">
        <router-outlet />
      </main>
    } @else {
      <router-outlet />
    }
  `,
  styles: [`
    .main-content {
      position: fixed;
      top: var(--topbar-h);
      left: var(--sidebar-w);
      right: 0;
      bottom: 0;
      overflow-y: auto;
    }
    @media (max-width: 1023px) {
      .main-content { left: 0; }
    }
  `]
})
export class App {
  private readonly router = inject(Router);

  private readonly navEnd = toSignal(
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(e => (e as NavigationEnd).urlAfterRedirects)
    )
  );

  showLayout = computed(() => {
    const url = this.navEnd();
    if (!url) return false;
    return !url.startsWith('/login') && !url.startsWith('/auth');
  });
}
